/**
 * A class for working with and downloading files from byte arrays.
 */
export default class Blob {
  /**
   * Downloads a file from a byte array.
   * @param {Uint8Array} fileBytes - The byte array of the file.
   * @param {string} fileName - The name of the file to be downloaded.
   */
  download(fileBytes: Uint8Array, fileName: string) {
    try {
      // Convert the byte array to a Blob
      const blob = new window.Blob([fileBytes], { type: 'text/csv;charset=utf-8;' });

      // Create a URL for the Blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link element and trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link); // Required for Firefox

      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url); // Clean up by revoking the Blob URL
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  }
}
